/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailReply = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.742 4 2 12l7.742 8L11 18.7l-5.523-5.707 14.626-.04L20.066 17h2v-6H5.484L11 5.3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEmailReply as EmailReply };
